import React, { useState} from "react";
import "./Styles.css";
import {Button, FormGroup, FormControl}from '@mui/material';
import { AIObjectCheckbox } from "./ai_checkbox";
import {SaveAlert} from "./save_alerts";

export const AIObjects = ({apiConfig, aiobjects, onEditAIobject, selectedAIObject, onSelectAIObject, onDeleteAIObject, onCreateAIConfig}) => {

  const [alertOpen, setAlertOpen]=useState(false);

  const message = () => {
    console.log(selectedAIObject)
    if (selectedAIObject.length === 0) {
        return "You have not selected any AI object.";
    } 
    if (selectedAIObject.length === 1) {
        return "You have selected the AI object: " + selectedAIObject[0].ObjectClass;
    } else {
      var selectedAIObjects = []
      selectedAIObject.forEach(element => {
        selectedAIObjects.push(element.ObjectClass)
      });
        return "You have selected the AI objects: " + selectedAIObjects.join(", ");
    }
  }


  const handleYes =() => {
    setAlertOpen(false);
    onCreateAIConfig(selectedAIObject);
  }

  const [deleteAlert, setDeleteAlert] = useState(null);

const handleDeleteYes =(aiObjectId) => {
  setDeleteAlert(false);
  // deleteEndpoint(epName)
  // apiConfig.deleteEndpoint(endpointId)
  onDeleteAIObject(aiObjectId)
}

  return (
    <div className="middle">
      <FormControl component="fieldset" className='EpFormControl'>
        <FormGroup className='FormGroup'>
          {aiobjects.map((aiobject) => (
            <div key={aiobject.Id} className="epCheckbox">
              <AIObjectCheckbox
                value={aiobject.ObjectClass}
                checked={selectedAIObject.includes(aiobject)} //sets the initial checkbox
                onChange={() => onSelectAIObject(aiobject)} //updates to the checked ep
                name={aiobject.ObjectClass}
                label={aiobject.GPTPrompt.concat(", AI Class: ", aiobject.ObjectClass)}
                onClick={() => onEditAIobject(aiobject)}
                onClickdel={() => setDeleteAlert(aiobject.Id)}
              />
            </div>
          ))}
          </FormGroup>
          <Button onClick={() => setAlertOpen(true)} variant="contained" className='SaveButton'>Save</Button> 
        
          {alertOpen && <SaveAlert onClose={() => setAlertOpen(false)} onYes={handleYes} heading={"Save AI object?"} message={message} linkTo = {false}/>}
          {deleteAlert && <SaveAlert onClose={() => setDeleteAlert(null)} onYes={() => handleDeleteYes(deleteAlert)} heading={"Delete AI object?"} message={null} />}
          
      </FormControl>
    </div>
  );
};

export default AIObjects;